import React from 'react';
import { observer } from 'mobx-react-lite';
import { Alert } from 'src/domains/common/components/alert/alert';
import { Button } from 'src/domains/common/components/button/button';
import { GamstopPreviouslyPositiveState } from 'src/components/ComplianceConfiguration/GamstopPreviouslyPositive/GamstopPreviouslyPositive.state';
import {
    GamstopPreviouslyPositiveSection,
    GamstopPreviouslyPositiveSectionTitle,
    GamstopPreviouslyPositiveTestTriggerActions,
    GamstopPreviouslyPositiveTestTriggerField,
    GamstopPreviouslyPositiveTestTriggerInput,
    GamstopPreviouslyPositiveTestTriggerLabel,
} from 'src/components/ComplianceConfiguration/GamstopPreviouslyPositive/GamstopPreviouslyPositive.style';

interface GamstopPreviouslyPositiveTestTriggerPanelPropsType {
    state: GamstopPreviouslyPositiveState;
}

export const GamstopPreviouslyPositiveTestTriggerPanel = observer(
    ({ state }: GamstopPreviouslyPositiveTestTriggerPanelPropsType): JSX.Element | null => {
        if (!state.isTestTriggerAvailable) {
            return null;
        }

        return (
            <GamstopPreviouslyPositiveSection data-test='gamstop-pp-test-trigger-panel'>
                <GamstopPreviouslyPositiveSectionTitle>Test automation</GamstopPreviouslyPositiveSectionTitle>

                <Alert
                    icon='info'
                    title='Runs the saved automation on a specific account. Use only for testing in non-production environments.'
                    variant='default'
                />

                {state.triggerFeedbackMessage === null ? null : (
                    <Alert
                        icon='info'
                        title={state.triggerFeedbackMessage}
                        variant={state.triggerFeedbackVariant}
                    />
                )}

                <GamstopPreviouslyPositiveTestTriggerField>
                    <GamstopPreviouslyPositiveTestTriggerLabel htmlFor='gamstop-pp-test-account-id'>
                        Account ID
                    </GamstopPreviouslyPositiveTestTriggerLabel>
                    <GamstopPreviouslyPositiveTestTriggerInput
                        data-test='gamstop-pp-test-account-id'
                        id='gamstop-pp-test-account-id'
                        inputMode='numeric'
                        onChange={(event): void => {
                            state.setTestAccountId(event.target.value);
                        }}
                        placeholder='Enter account ID'
                        type='text'
                        value={state.testAccountId}
                    />
                </GamstopPreviouslyPositiveTestTriggerField>

                <GamstopPreviouslyPositiveTestTriggerActions>
                    <Button
                        dataTest='gamstop-pp-trigger-automation'
                        disabled={!state.canTriggerAutomation}
                        isLoading={state.isTriggering}
                        onClick={(): void => {
                            void state.triggerAutomation();
                        }}
                        type='button'
                        variant='outline'
                    >
                        Trigger automation
                    </Button>
                </GamstopPreviouslyPositiveTestTriggerActions>
            </GamstopPreviouslyPositiveSection>
        );
    }
);
